export const exportColumns = {
    Retaurant_Name: { name: "Restaurant Name", active: true },
    ID: { name: "ID", active: true },
    Number: { name: "Number", active: true },
    Type: { name: "Type", active: true },
    Created: { name: "Created", active: true },
    Status: { name: "Status", active: true },
    Order_Type: { name: "Order Type", active: true },
    Due: { name: "Due", active: true },
    Payment_Method: { name: "Payment Method", active: true },
    Pick_Up_Address: { name: "Pick Up Address", active: true },
    Pick_Up_City: { name: "Pick Up City", active: true },
    Pick_Up_State: { name: "Pick Up State", active: true },
    Pick_Up_Zip: { name: "Pick Up Zip", active: true },
    Pick_Up_Country: { name: "Pick Up Country", active: true },
    Cart: { name: "Cart", active: true },
    Delivery_Fee: { name: "Fee", active: true },
    Tips: { name: "Tips", active: true },
    Discount: { name: "Discount", active: true },
    Promo_Codes: { name: "Promo Codes", active: false },
    Tax: { name: "Tax", active: true },
    Total: { name: "Total", active: true },
    Number_Of_Items: { name: "Number Of Items", active: true },
    Name: { name: "Name", active: true },
    E_Mail: { name: "E-Mail", active: true },
    Phone: { name: "Phone", active: true },
    Delivery_Address: { name: "Delivery Address", active: true },
    Delivery_Distance: { name: "Delivery Distance", active: true },
    Pick_Up_Time: { name: "Pick Up Time", active: false },
    Order_Items: { name: "Order Items", active: false },
    Detailed_Option_Sets: { name: "Detailed Option Sets", active: false },
    Order_Notes: { name: "Order Notes", active: false },
    Custom_Checkout_Fields: { name: "Custom Checkout Field", active: false }
};
export var OrderTypes;
(function (OrderTypes) {
    OrderTypes["All"] = "all";
    OrderTypes["Now"] = "now";
    OrderTypes["Later"] = "later";
})(OrderTypes || (OrderTypes = {}));
export var ServiceTypes;
(function (ServiceTypes) {
    ServiceTypes["All"] = "all";
    ServiceTypes["Pickup"] = "pickup";
    ServiceTypes["Delivery"] = "delivery";
    ServiceTypes["DineIn"] = "dine_in";
})(ServiceTypes || (ServiceTypes = {}));
//# sourceMappingURL=export.js.map